var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    className: "i_icon_svg__st0",
    d: "M6 .9c2.8 0 5.1 2.3 5.1 5.1S8.8 11.1 6 11.1.9 8.8.9 6 3.2.9 6 .9M6 0C2.7 0 0 2.7 0 6s2.7 6 6 6 6-2.7 6-6-2.7-6-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777",
    className: "i_icon_svg__st0",
    d: "M4.8 9.3c.2 0 .3-.1.4-.1 0-.1.1-.2.1-.5V5.6c0-.2 0-.4-.1-.4-.1-.1-.2-.1-.4-.1v-.3h2v4c0 .2 0 .4.1.4.1.1.2.1.4.2v.2H4.8v-.3zm.7-6.7c.1-.1.3-.2.5-.2s.4.1.6.2c.1.2.2.4.2.6s-.1.4-.2.6c-.2.1-.4.2-.6.2-.2 0-.4-.1-.5-.2-.2-.2-.3-.4-.3-.6 0-.2.1-.4.3-.6z"
  })));
}
export default SvgIIcon;